var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/input/voice/record.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-voice J_Record\">\n  <div class=\"m-voice-status im-avatar-wrap\">\n    <ul class=\"left-wave\">\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n    </ul>\n    <div class=\"im-avatar\">\n      <div class=\"avatar-wrap J_Robot\">\n        <div class=\"avatar-head\"></div>\n        <div class=\"avatar-body\"></div>\n        <div class=\"avatar-tie\"></div>\n      </div>\n    </div>\n    <ul class=\"right-wave\">\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n    </ul>\n  </div>\n  <div class=\"m-voice-msg\">\n      <p class=\"msg-record\">松开发送 上滑取消</p>\n      <p class=\"msg-cancel\">松开手指 取消发送</p>\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/input/voice/record.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/view/footer/input/voice/record.html
// module id = 172
// module chunks = 0 1